import { css } from "@emotion/react";
import { MEDIA_QUERY_FOR_PC } from "constants/mediaQueryForPc";
import { MEDIA_QUERY_FOR_SP } from "constants/mediaQueryForSp";

import { MODAL_HEADER_HEIGHT } from "./constants/modalHeaderHeight";

export const headerStyle = css`
  height: ${MODAL_HEADER_HEIGHT}px; /* modalStyle で grid-template-rows を指定する関係 */
  border-bottom: 1px solid #e0e0e0;
  flex-shrink: 0;

  opacity: 1;
  gap: 10px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  border: none;

  ${MEDIA_QUERY_FOR_PC} {
    padding: 16px 24px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    padding: 12px 18px;
  }
`;

export const modalCloseButtonStyle = css`
  background: none;
  border: none;
  cursor: pointer;
  height: 24px;
  padding: 0;
  width: 23px;
`;

export const modalCloseIconStyle = css`
  color: #a3a3a3;

  ${MEDIA_QUERY_FOR_PC} {
    height: 20px;
    width: 20px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    height: 18px;
    width: 18px;
  }
`;

export const titleStyle = css`
  margin: 0;
  font-family: "YuGothic", sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.5;
  letter-spacing: 0;
  color: #000000;
`;
